// extracted by mini-css-extract-plugin
export var text = "_4q-0";